/**
 * parseTimeZone parses time zone from string to number
 * @param timeZone {Number} time zone as string
 * @returns time zone {String} the current time zone as number
 */
var cache = {};
export function parseTimeZone(timeZone) {
    if (!cache[timeZone]) {
        var timeZoneAsNumber = parseInt(timeZone) || 0;
        cache[timeZone] = timeZoneAsNumber;
    }
    return cache[timeZone];
}
//# sourceMappingURL=TimeZoneParser.js.map